// const REACT_APP_API = process.env.REACT_APP_API;
const REACT_APP_API = "https://srs-project.eoraa.com/";
// const REACT_APP_API = "https://stabiz.eoraa.com/api/v1"
export { REACT_APP_API };
